import React, { Component } from 'react';

// pop-ups
import { toast } from 'react-toastify';

// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import {Alert, Button, Card, TextField} from '@betareader/design-system';

import ReactGA from 'react-ga';

// i18n
import { withTranslation } from 'react-i18next';
import { authUtil } from '../../utils';
import featureToggleUtil from '../../utils/featureToggleUtil';

export class NewBook extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: '',
      loading: false
    };
  }

  createBook = async event => {
    event.preventDefault();
    const { changePage, activeAccount, userProfile } = this.props;
    const title = this.state.title.trim();
    if (!title || title.length > 60 || this.state.loading) return;
    this.setState({loading: true});
    try {
      const idToken = await authUtil.getFreshIdToken();
      if (!idToken) throw new Error('Missing token');
      const response = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/books`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'br-token': idToken
        },
        body: JSON.stringify({
          title,
          accountId: activeAccount?._id || userProfile?.account?._id,
          // Authors in the scene-editor beta create new books in the
          // scene-structured tiptap format; everyone else stays on draftjs.
          ...(featureToggleUtil.hasFeatureAccess(userProfile, 'scene_editor')
            ? {contentFormat: 'tiptap'}
            : {})
        })
      });
      if (!response.ok) throw new Error('Failed to add book');
      const newBook = await response.json();
      ReactGA.event({category: 'Book Management', action: 'Added New Book'});
      if (newBook?._id) changePage(`/books/${newBook._id}`);
    } catch (error) {
      ReactGA.exception({description: 'Failed to add book', fatal: true});
      toast.error('Failed to add book');
    } finally {
      this.setState({loading: false});
    }
  }

  handleTitleChange = event => {
    this.setState({title: event.target.value});
  }

  render() {
    const { t } = this.props;
    const { title, loading } = this.state;

    const faultyInput = title && title.length > 60;

    return (
      <Card style={{padding: 'var(--br-space-4)'}}>
        <form onSubmit={this.createBook} style={{display: 'grid', gap: 'var(--br-space-3)'}}>
          {faultyInput && <Alert variant='error'>{t('TooLongTitle')}</Alert>}
          <TextField id='new-book-title' label={t('Title')} placeholder={t('Title')}
            value={title} onChange={this.handleTitleChange} maxLength={61} />
          <Button type='submit' disabled={Boolean(faultyInput) || !title.trim() || loading}
            aria-busy={loading}>{loading ? t('Creating') : t('Create')}</Button>
        </form>
      </Card>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  userProfile: state.user.userProfile,
  activeAccount: state.account.activeAccount
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(NewBook)));
